import { render, staticRenderFns } from "./InsButterfly.vue?vue&type=template&id=a40edeea&scoped=true&"
import script from "./InsButterfly.vue?vue&type=script&lang=ts&"
export * from "./InsButterfly.vue?vue&type=script&lang=ts&"
import style0 from "./InsButterfly.vue?vue&type=style&index=0&id=a40edeea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40edeea",
  null
  
)

export default component.exports